import React from 'react';
import { useAuth } from '../auth/AuthContext';
import { ThemeToggle } from './ThemeToggle';

/** Shows who is signed in, with a way out. Rendered in the app header. */
export const SessionBadge: React.FC = () => {
  const { user, signOut } = useAuth();
  if (!user) return null;

  return (
    <div className="session-badge">
      {/* Recorded events (/events) and accounts (/admin) are reached by URL;
          the header stays lean for the screens that live on a tablet. */}
      <span className="session-username">{user.displayName}</span>
      <button
        className="session-signout"
        type="button"
        onClick={() => signOut()}
      >
        Sign out
      </button>
      <ThemeToggle />
    </div>
  );
};
